import styled from 'styled-components';

export const StyledMapDashboard = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .iot-wrapper {
    position: absolute;
    left: 28px;
    top: 28px;
    z-index: 2;
  }

  .alert-wrapper {
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
  }
`;
